import React, { useRef } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";

const FactorsAndMultiples = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.FACTORS_AND_MULTIPLES }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.FACTORS_AND_MULTIPLES }}`;
  const mapData = ( v, i ) => i ? v.slice( v.indexOf( '\\begin{align}' ) + '\\begin{align}'.length, v.indexOf( '\\end{align}' ) ).split( '\\\\' ).map( v => v.trim() ) : [ v.trim() ];
  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '&' ).map( mapData );
  const changedDataCount = data.reduce( ( r, v, i ) => r + v.filter( ( vv, ii ) => ( prevData.current[ i ] && prevData.current[ i ][ ii ] ) !== vv ).length, 0 );

  const MathJaxNode = getMathJaxNode( props.type );

  let rowsIndex;

  const mapColumns = ( value, index ) => {
    rowsIndex = index;
    return value.map( mapRows );
  };

  const mapRows = ( value, index ) => {
    const columns = <span key={ index } className="inputTxtN"><MathJaxNode onRender={ renderMathJax }>{ value }</MathJaxNode></span>;
    return rowsIndex ? <li key={ index }>{ columns }</li> : columns;
  };

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  const COLUMNS = data.map( mapColumns );

  return (
    <table className="tbl-htreeM">
      <tbody>
      <tr>
        <td><span className="divisorBox">{ COLUMNS[ 0 ] }</span></td>
        <td><ul className="multiline-inputList">{ COLUMNS[ 1 ] }</ul></td>
      </tr>
      </tbody>
    </table>
  );

};

export default FactorsAndMultiples;
